module.exports = __webpack_public_path__ + "img/design_factures_mobile.43e322ec.jpg";